export const FRESH = 'FRESH'
export const BIDDING = 'BIDDING'
export const WAITING_TO_BE_CLAIMED = 'WAITING_TO_BE_CLAIMED'
export const SOLD = 'SOLD'
export const BIDDING_DISABLED = 'BIDDING_DISABLED'
